import type { HelpArticleSlug, HelpCategory } from '@osteopro/shared';

/** Adresses du centre d'Aide, lues par la table de routes et par les écrans qui y renvoient. */

export const HELP_CENTER_PATH = '/aide/articles';

export function helpArticlePath(slug: HelpArticleSlug): string {
  return `${HELP_CENTER_PATH}/${slug}`;
}

export function helpCategoryPath(category: HelpCategory): string {
  return `${HELP_CENTER_PATH}?categorie=${category}`;
}

export function helpSearchPath(query: string): string {
  return `${HELP_CENTER_PATH}?q=${encodeURIComponent(query)}`;
}
